import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Thumbs, Pagination, Autoplay } from 'swiper';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import EFVideo from '@/components/UI/EFVideo';
import SVGPlay from '@/components/UI/svg/corporatesocialresponsibility/SVGPlay';

export default function CardModal({ title, desc, imgs, onClose, webpImg, img }: any) {
    const handlePlay = (cls: string) => {
        const target = document.querySelector(`.card-modal ${cls}`) as HTMLVideoElement;
        target.play();
        const icon = document.querySelector('.card-modal .play-icon') as HTMLElement;
        icon.classList.add('hide');
    };
    const handleEnd = (cls: string) => {
        const target = document.querySelector(`.card-modal ${cls}`) as HTMLVideoElement;
        target.pause();
        target.currentTime = 0;
        const icon = document.querySelector('.card-modal .play-icon') as HTMLElement;
        icon.classList.remove('hide');
    };
    return (
        <div className={`card-modal ${css['card-modal']}`}>
            <div className={`modal-content`}>
                <div className="modal-inner">
                    <div className="close" onClick={onClose}>
                        &times;
                    </div>
                    {imgs?.length > 0 && (
                        <div className="swiper-imgs">
                            <Swiper
                                className={`swiper-box ${imgs?.length === 1 ? 'single' : ''}`}
                                loop={imgs?.length > 1}
                                navigation={true}
                                slidesPerView={'auto'}
                                lazy={true}
                                autoplay={{
                                    delay: 4000,
                                    disableOnInteraction: false,
                                }}
                                pagination={{ clickable: true }}
                                spaceBetween={0}
                                centeredSlides={true}
                                speed={800}
                                effect="flip"
                                modules={[FreeMode, Navigation, Thumbs, Pagination, Autoplay]}
                            >
                                {imgs.map((item: any, k: number) => (
                                    <SwiperSlide key={k}>
                                        {(Array.isArray(item) && String(item[0])?.endsWith('.mp4')) || String(item[0]).endsWith('.webm') ? (
                                            <div className="video-box" onClick={() => handlePlay(`.video-${k}`)}>
                                                <EFVideo
                                                    className={`fullImgs video-${k}`}
                                                    sources={item}
                                                    width="100%"
                                                    height="100%"
                                                    autoPlay={false}
                                                    muted={false}
                                                    loop={false}
                                                    aria-label={title}
                                                    onEnded={() => handleEnd(`.video-${k}`)}
                                                    // poster={handleDynamicPath(webpImg || img)}
                                                    // @ts-ignore
                                                    controls
                                                />
                                                <SVGPlay className="play-icon" />
                                            </div>
                                        ) : (
                                            <NextImage className="fullImgs" webpSrc={item[0]} src={item[1] || item[0]} alt={title} aria-label={title} />
                                        )}
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}
                    <div className="modal-text">
                        <p className="modal-title">{title}</p>
                        <p className="modal-desc">{desc}</p>
                    </div>
                </div>
            </div>
            <style global jsx>
                {`
                    .ecoflow-mobile {
                        height: 100vh !important;
                        overflow: hidden !important;
                    }
                    #allContentContainer {
                        z-index: 1011;
                    }
                `}
            </style>
        </div>
    );
}
